import React from 'react';
import { TextField, useTheme } from '@mui/material';
import { THEME_COLORS } from '../../constants/theme';

/**
 * Reusable TextField Component
 * 
 * Provides consistent theming and styling across all forms.
 * Automatically adapts to light/dark theme.
 * 
 * @component
 * @example
 * <FormTextField
 *   label="Email"
 *   type="email"
 *   value={email}
 *   onChange={(e) => setEmail(e.target.value)}
 *   required
 * />
 */
const FormTextField = ({ 
  fullWidth = true,
  size = 'small',
  variant = 'outlined',
  sx = {}, 
  ...props 
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: THEME_COLORS.PRIMARY,
          },
          '&:hover fieldset': {
            borderColor: THEME_COLORS.PRIMARY,
          },
          '&.Mui-focused fieldset': {
            borderColor: THEME_COLORS.PRIMARY,
          },
          '& input': {
            color: isDark ? THEME_COLORS.TEXT_PRIMARY_DARK : THEME_COLORS.TEXT_PRIMARY_LIGHT,
          },
        },
        '& .MuiInputLabel-root': {
          color: isDark ? THEME_COLORS.TEXT_SECONDARY_DARK : THEME_COLORS.TEXT_SECONDARY_LIGHT,
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: THEME_COLORS.PRIMARY,
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default FormTextField;

